import React, { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';

const withScrollReveal = (Component) => {
  return function ScrollRevealComponent(props) {
    const [ref, inView] = useInView({ triggerOnce: true });
    const controls = useAnimation();
    const revealRef = useRef();

    useEffect(() => {
      if (inView) {
        controls.start('visible');
      }
    }, [controls, inView]);

    return (
      <div ref={ref} className="scroll-reveal-container">
        <motion.div
          ref={revealRef}
          initial="hidden"
          animate={controls}
          variants={{
            visible: { opacity: 1, x: 0  },
            hidden: { opacity: 0, x: -50 },
          }}
          transition={{ duration: 0.8 , delay: 0.5}}
          className="scroll-reveal"
        >
          <Component {...props} />
        </motion.div>
      </div>
    );
  };
};

export default withScrollReveal;
